import React from "react";
import styles from '../checkout/progressbar.module.scss';

const ProgressBar = ({ currentStep, totalSteps, onNext, onPrevious }) => {
    const stepNames = ["1", "2", "3", "4"];
    const stepColors = ["#100505", "#100505", "#100505", "#100505"];

    const handleStepClick = (index) => {
        if (index < currentStep) {
            onPrevious(index);
        } else if (index > currentStep) {
            onNext(index);
        }
    };

    return (
        <>
            <div className={styles.ProgressBarmain}>
                {stepNames.map((stepName, index) => (
                    <div className={styles.step} key={index}>
                        <div
                            className={`${styles.stepName} ${currentStep > index + 1 ? styles.completed : ""}`}
                            style={{
                                color: currentStep > index + 1 ? stepColors[index] : "#100505",
                            }}
                        ></div>
                        {index < totalSteps - 1 && (
                            <div
                                className={`${styles.stepDivider} ${currentStep > index + 1 ? styles.completed : ""}`}
                                style={{
                                    backgroundColor: currentStep > index + 1 ? stepColors[index] : "#CFCDCD",
                                }}
                            ></div>
                        )}
                    </div>
                ))}
            </div>
            <div className={styles.stepprogressbar}>
                {stepNames.map((stepName, index) => (
                    <div key={index} className={styles.stepprogressbarbtn}>
                        <button
                            onClick={() => handleStepClick(index + 1)}
                            className={`${currentStep === index + 1 ? styles.currentStep : styles.Stepallbtn}`}
                        >
                            {stepName}
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
};

export default ProgressBar;
